// Lightweight SPA meta helper for per-page titles, descriptions, and share tags.
// Note: client-rendered meta serves browsers and modern crawlers; some social
// scrapers read only server HTML (documented limitation for the poster URLs).

const DEFAULT_TITLE = 'Vote Steve Lesperance | Ward 8 Councillor, Kawartha Lakes';

const ensureMeta = (attr, key) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  return el;
};

export const setPageMeta = ({ title, description, ogTitle, ogDescription, ogImage, url } = {}) => {
  document.title = title || DEFAULT_TITLE;
  if (description !== undefined) ensureMeta('name', 'description').setAttribute('content', description || '');
  ensureMeta('property', 'og:title').setAttribute('content', ogTitle || title || DEFAULT_TITLE);
  if (ogDescription !== undefined || description !== undefined) {
    ensureMeta('property', 'og:description').setAttribute('content', ogDescription || description || '');
  }
  if (ogImage) ensureMeta('property', 'og:image').setAttribute('content', ogImage);
  ensureMeta('property', 'og:url').setAttribute('content', url || window.location.href);
  ensureMeta('property', 'og:type').setAttribute('content', 'website');
};

export const resetPageMeta = () => setPageMeta({ title: DEFAULT_TITLE });
